import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim() || !message.trim()) {
      alert('Please fill in both email and message fields.');
      return;
    }
    alert('Queries submitted!');
    setEmail('');
    setMessage('');
  };

  return (
    <section className="contact">
      <h2>Get in Touch</h2>
      <p className="contact-subtitle">
        Let's connect! Reach me via email or social media, or send a message below.
      </p>

      {/* Social Links Grid */}
      <div className="contact-links-grid">
        <a href="mailto:pandeyrabin220@gmail.com" className="contact-card email">
          <i className="fas fa-envelope"></i>
          <span>pandeyrabin220@gmail.com</span>
        </a>
        <a href="https://www.linkedin.com/in/rabin-pandey-886bb9361/" target="_blank" rel="noopener noreferrer" className="contact-card linkedin">
          <i className="fab fa-linkedin"></i>
          <span>Rabin Pandey</span>
        </a>
        <a href="https://github.com/rabinpandey123" target="_blank" rel="noopener noreferrer" className="contact-card github">
          <i className="fab fa-github"></i>
          <span>rabinpandey123</span>
        </a>
        <a href="https://www.facebook.com/rabin.pandey.52438" target="_blank" rel="noopener noreferrer" className="contact-card facebook">
          <i className="fab fa-facebook"></i>
          <span>Rabin Pandey</span>
        </a>
        <a href="https://www.instagram.com/rabinnpande?igsh=aW4zMWJva3loN2R2" target="_blank" rel="noopener noreferrer" className="contact-card Instagram">
          <i className="fab fa-instagram"></i>
          <span>Rabin Pandey</span>
        </a>
      </div>

      {/* Contact Form */}
      <div className="contact-form-wrapper">
        <h3>Send a Message</h3>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Your Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Your Message / Query</label>
            <textarea
              id="message"
              rows="5"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your message here..."
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-btn">Submit Query</button>
        </form>
      </div>
    </section>
  );
};

export default Contact;